import AccountingAndFinance from "./Accounting&FinanceSkills.json";
import Agriculture from "./AgricultureSkills.json";
import CombinedSkills from "./combinedSkills.json";
import DesignAndArchitecture from "./Design&ArchitectureSkills.json";
import Education from "./EducationSkills.json";
import Engineering from "./EngineeringSkills.json";
import HealthcareAndMedical from "./Healthcare&Medicalskills.json";
import HospitalityAndTourism from "./Hospitality&TourismSkills.json";
import HumanResourcesAndRecruitment from "./HumanResourceSkills.json";
import InformationTechnology from "./InformationTechnologySkills.json";
import Insurance from "./InsuranceSkills.json";
import Legal from "./LegalSkills.json";
import MarketingAndCommunications from "./Marketing&CommunicationsSkills.json";
import RealEstateAndProperty from "./RealEstate&PropertySkills.json";
import SportsAndRecreation from "./Sports&RecreationSkills.json";

//Banking And Finance	Accounting & Finance Skills
// Accounting	Accounting & Finance Skills
// Marketing And Communications	Marketing & Communications Skills
// Insurance	Insurance Skills
// Information Technology	Information Technology Skills
// Agriculture	Agriculture Skills
// Education	Education Skills
// Engineering	Engineering Skills
// Healthcare And Medical	Healthcare & Medical skills
// Human Resources & Recruitment	Human Resource Skills
// Operations	Education Skills
// Sales	Marketing & Communications Skills
// Administration & Office Support	Education Skills
// Advertising Arts and Design	Marketing & Communications Skills
// Business Development	Marketing & Communications Skills
// Community Services & Development	Education Skills
// Consulting and Strategy	Marketing & Communications Skills
// Customer Service	Marketing & Communications Skills
// Design And Architecture	Design & Architecture Skills
// Hospitality And Tourism	Hospitality & Tourism Skills
// Legal	Legal Skills
// Real Estate And Property	Real Estate & Property Skills
// Retail & Consumer	Marketing & Communications Skills
// Sports And Recreation	Sports & Recreation Skills
// Government And Defense	Education Skills

/**
 * Skill suggestions per Area of Expertise.
 *
 * Every key MUST be the lower-cased text of an option in the Area of Expertise
 * dropdown (`seed/dropDownOptions.js`). The old map was written against a
 * different, older wording — `"banking and finance"`, `"retail & consumer"`,
 * `"human resources & recruitment"` — so 13 of the 30 selectable areas matched
 * nothing and their "Select Skills" dialog opened completely empty. One key
 * (`"Consulting and Strategy"`) was also mixed case, and the lookup lower-cases,
 * so it could never be hit either.
 */
export const JOB_FUNCTION_MAPPING = {
	["accounting"]: AccountingAndFinance,
	["administration and office support"]: Education,
	["advertising, arts and media"]: MarketingAndCommunications,
	["agriculture"]: Agriculture,
	["banking"]: AccountingAndFinance,
	["business development"]: MarketingAndCommunications,
	["civil engineering"]: Engineering,
	["community services and development"]: Education,
	["consulting and strategy"]: MarketingAndCommunications,
	["customer service"]: MarketingAndCommunications,
	["design and architecture"]: DesignAndArchitecture,
	["education"]: Education,
	["engineering"]: Engineering,
	["finance"]: AccountingAndFinance,
	["healthcare and medical"]: HealthcareAndMedical,
	["hospitality and tourism"]: HospitalityAndTourism,
	["human resources and recruitment"]: HumanResourcesAndRecruitment,
	["information technology"]: InformationTechnology,
	["insurance"]: Insurance,
	["legal"]: Legal,
	["marketing and communications"]: MarketingAndCommunications,
	["operations"]: Education,
	["real estate and property"]: RealEstateAndProperty,
	["retail and consumer goods"]: MarketingAndCommunications,
	["sales"]: MarketingAndCommunications,
	["sports and recreation"]: SportsAndRecreation,
	["telecommunications"]: InformationTechnology,
	// Kept for resumes saved under the older wording.
	["banking and finance"]: AccountingAndFinance,
	["government and defense"]: Education,
};

/**
 * Suggestions for an Area of Expertise, never empty.
 *
 * `Environmental Services`, `Security` and `Transport and Logistics` have no
 * dedicated skill set yet, so they fall back to the combined list rather than
 * opening an empty dialog. Assign them a set of their own when one exists.
 *
 * Matches on the whole value first. The callers used to key on
 * `jobFunction.split(",")[0]`, which turned "Advertising, Arts and Media" into
 * "advertising" and matched nothing — the comma split is only a fallback now.
 */
export function skillsForJobFunction(jobFunction) {
	const value = (jobFunction || "").toString().trim().toLowerCase();
	if (!value) return CombinedSkills;

	return JOB_FUNCTION_MAPPING[value] || JOB_FUNCTION_MAPPING[value.split(",")[0].trim()] || CombinedSkills;
}
